/* eslint-disable i18next/no-literal-string -- a class name and an attribute name, not copy */
import { useSyncExternalStore } from 'react';

const isDark = () => document.documentElement.classList.contains('dark');

function subscribe(onChange: () => void) {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => {
    observer.disconnect();
  };
}

/** Whether the app is dark right now: the theme toggle sets `dark` on <html>. */
export function useDocumentDark(): boolean {
  return useSyncExternalStore(subscribe, isDark, () => false);
}
